import { useSiteContent } from "@/shared/content/SiteContentProvider"
import { useInView } from "@/shared/hooks/useInView"
import { Reveal } from "@/shared/ui/Reveal"
import { Section } from "@/shared/ui/Section"
import { SectionHeading } from "@/shared/ui/SectionHeading"
import { Icon } from "@/shared/ui/icons"

export function BenefitsSection() {
  const { benefits } = useSiteContent()
  const { ref, inView } = useInView()

  return (
    <Section ref={ref} tone="off-white">
      <Reveal inView={inView} className="mb-14 max-w-xl">
        <SectionHeading
          eyebrow="Diferenciais"
          title={
            <>
              Mais do que atender:
              <br className="hidden lg:block" /> cuidar antes que seja necessário
            </>
          }
        />
      </Reveal>

      <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
        {benefits.map((benefit, index) => (
          <Reveal key={benefit.title} inView={inView} delayMs={index * 80} distance="lg" className="h-full">
            <article className="group h-full flex flex-col gap-5 p-7 rounded-2xl bg-white border border-verde-profundo/8 hover:border-dourado/40 hover:shadow-lg hover:-translate-y-1 transition-all duration-300">
              <div className="flex items-start justify-between">
                <div className="w-12 h-12 rounded-xl bg-verde-profundo/5 flex items-center justify-center text-verde-profundo group-hover:bg-verde-profundo group-hover:text-dourado-claro transition-all duration-300">
                  <Icon name={benefit.icon} />
                </div>
                <span
                  className="text-5xl font-bold text-verde-profundo/6 leading-none select-none group-hover:text-dourado-escuro/15 transition-colors duration-300"
                  aria-hidden="true"
                >
                  {String(index + 1).padStart(2, "0")}
                </span>
              </div>

              <div className="flex flex-col gap-2">
                <h3 className="text-lg font-semibold text-verde-profundo">{benefit.title}</h3>
                <p className="text-sm text-verde-profundo/55 leading-relaxed">{benefit.description}</p>
              </div>

              <div className="h-px bg-gradient-to-r from-dourado/0 via-dourado/40 to-dourado/0 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left mt-auto" />
            </article>
          </Reveal>
        ))}
      </div>
    </Section>
  )
}
